import { model as i18n } from '!/i18n'
import { createEvent, createStore, sample } from 'effector'
import * as model from './model'

export const $creditCardNumberError = createStore<string>('')
export const $creditCardExpirationTimeError = createStore<string>('')
export const $creditCardCvvError = createStore<string>('')

export const validateCreditCardFields = createEvent()

// Validate credit card number
sample({
  clock: validateCreditCardFields,
  source: {
    i18n: i18n.$t,
    number: model.$creditCardNumber,
  },
  filter: ({ number }) => !number,
  fn: ({ i18n: { t } }) => t('card_number_error'),
  target: $creditCardNumberError,
})

// Validate credit card expiration date
sample({
  clock: validateCreditCardFields,
  source: {
    month: model.$creditCardMonth,
    year: model.$creditCardYear,
    i18n: i18n.$t,
  },
  filter: ({ month, year }) => !month || !year,
  fn: ({ i18n: { t } }) => t('expiry_date_error'),
  target: $creditCardExpirationTimeError,
})

// Validate credit card security code
sample({
  clock: validateCreditCardFields,
  source: {
    cvv: model.$creditCardCvv,
    i18n: i18n.$t,
  },
  filter: ({ cvv }) => !cvv,
  fn: ({ i18n: { t } }) => t('security_code_error'),
  target: $creditCardCvvError,
})

// Reset errors
sample({
  clock: model.$creditCardNumber,
  fn: () => '',
  target: $creditCardNumberError,
})

sample({
  clock: [model.$creditCardMonth, model.$creditCardYear],
  fn: () => '',
  target: $creditCardExpirationTimeError,
})

sample({
  clock: model.$creditCardCvv,
  fn: () => '',
  target: $creditCardCvvError,
})
